const getEffectiveConnectionType = () => {
  const connection = typeof navigator !== 'undefined' && (
    navigator.connection
    || navigator.mozConnection
    || navigator.webkitConnection
  );

  return connection ? connection.effectiveType : '';
};

const performanceMetadata = () =>
  () => ({
    connection_type: getEffectiveConnectionType(),
  });

export default performanceMetadata;
